import useDynamicPage from "@/hooks/useDynamicPage";
import { DynamicPageSeo } from "@/ui/DynamicPageSeo";
import { BuilderContentBlocks } from "@/ui/BuilderContentBlocks";

export default function Homepage({ prefix, title, seo, canonical, data }) {
  return (
    <>
      <DynamicPageSeo
        {...seo}
        title={seo?.title.length > 0 ? seo.title : title}
        canonical={seo?.canonical.length > 0 ? seo.canonical : canonical}
      />
      <BuilderContentBlocks data={data} prefix={prefix} />
    </>
  );
}

export async function getStaticProps() {
  const page = useDynamicPage("/");

  return {
    props: {
      isBuilder: true,
      prefix: `page_homepage`,
      title: page.title,
      seo: page.seo,
      canonical: `/`,
      data: page.content,
    },
  };
}
